import { useContext, useEffect, useCallback } from 'react'
import { AuthContext } from 'elentari'
import api from '../../services/Api'

const VerifyLogin = () => {
  const context = useContext(AuthContext)

  const verifyToken = useCallback(async () => {
    const response = await api.getUserInfo()
    if (
      context.user &&
      (response.status === 401 || context.user.realm !== response.data.realm)
    ) {
      await api.logout()
      delete localStorage.user
      window.location.replace('/')
    }
  }, [context])
  useEffect(() => {
    verifyToken()
  }, [verifyToken])
  return null
}

export default VerifyLogin
